var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#434343"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2139_992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9547 8.27121C13.2663 7.71755 13.5261 7.21795 13.6864 6.8377C14.4645 4.99124 13.6951 2.86733 11.8142 2.00096C9.9333 1.13459 8.04459 2.03293 7.21567 3.76746C5.63055 2.67977 3.51606 2.83951 2.34999 4.53688C1.18391 6.23425 1.54988 8.45171 3.14699 9.66172C3.87183 10.2109 5.30538 11.0202 6.65504 11.7404M13.5811 9.79164C13.2293 7.90168 11.6212 6.51947 9.59645 6.89515C7.57168 7.27083 6.26248 9.09759 6.5362 11.0825C6.75612 12.6773 7.97002 16.419 8.43875 17.8283C8.50272 18.0207 8.5347 18.1168 8.59802 18.1839C8.65318 18.2423 8.72653 18.2847 8.8047 18.3032C8.89443 18.3245 8.9937 18.3041 9.19225 18.2634C10.6472 17.9646 14.4945 17.145 15.9856 16.5381C17.8414 15.7827 18.7992 13.7368 18.0818 11.7942C17.3644 9.85157 15.3937 9.15128 13.5811 9.79164Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2139_992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.cd4be87002624d12728b50ad53e193de.svg";
export { ForwardRef as ReactComponent };